import { hasAtMostDecimals, parseDecimal } from '../../pricing/model/format'

/** Предел `numeric(18,3)` службы: больше — 400, и PUT всего набора склада не пройдёт. */
export const MAX_COUNT = 999_999_999_999_999

/** Знаков после запятой: количество — `numeric(18,3)`, цена — `numeric(18,2)`. */
export const COUNT_DECIMALS = 3
export const PRICE_DECIMALS = 2

/** Текст поля по количеству: десятичная запятая; `null` — пустое поле. */
export const countText = (value: number | null): string => (value === null ? '' : String(value).replace('.', ','))

/** Количество из поля; пусто — `null` («не считали»), негодное — тоже `null` (см. `countProblem`). */
export const parseCount = (value: string): number | null => (value.trim() === '' ? null : parseDecimal(value))

/** Почему введённое не количество; `null` — годится (пусто — «не считали»). */
export function countProblem(value: string): string | null {
  if (value.trim() === '') return null
  const parsed = parseDecimal(value)
  if (parsed === null || parsed < 0) return 'Не число: количество — неотрицательное, через запятую'
  if (!hasAtMostDecimals(value, COUNT_DECIMALS)) return 'Не больше трёх знаков после запятой'
  if (parsed > MAX_COUNT) return 'Слишком большое количество'
  return null
}

/** Почему введённое не цена склада в диалоге создания; `null` — годится (пусто — «не задана»). */
export function priceProblem(raw: string, warehouseName: string): string | null {
  if (raw === '') return null
  const value = parseDecimal(raw)
  if (value === null || value < 0) return `${warehouseName}: цена — неотрицательное число`
  if (!hasAtMostDecimals(raw, PRICE_DECIMALS)) return `${warehouseName}: не больше двух знаков после запятой`
  return null
}

/** Цена из поля для отправки в 1С; пусто, негодное и ноль — «не задана» (`null`). */
export function parsePrice(raw: string): number | null {
  const value = parseDecimal(raw)
  return value === null || value <= 0 ? null : value
}
